import { createSlice } from "@reduxjs/toolkit";
import {
  AddTimezoneAction,
  DeleteTimezoneAction,
  GetAllTimezonesAction,
  UpdateTimezoneAction,
} from "store/middlewares/dataManagement/timezone";

export const timezoneSlice = createSlice({
  name: "timezone",
  initialState: {
    timezonesLoading: true,
    timezones: null,
  },
  extraReducers(builder) {
    builder
      //GET ALL
      .addCase(GetAllTimezonesAction.pending, (state) => {
        state.timezones =
          state.timezones?.data?.length > 0 ? state.timezones : null;
      })

      .addCase(GetAllTimezonesAction.fulfilled, (state, action) => {
        state.timezonesLoading = false;
        state.timezones = action.payload.response;
      })

      .addCase(GetAllTimezonesAction.rejected, (state) => {
        state.timezonesLoading = false;
        state.timezones = null;
      })

      // Delete
      .addCase(DeleteTimezoneAction.fulfilled, (state, action) => {
        state.timezonesLoading = false;

        state.timezones = action.payload.response;
      })

      // update
      .addCase(UpdateTimezoneAction.fulfilled, (state, action) => {
        state.timezonesLoading = false;

        state.timezones = {
          ...state.timezones,
          data: state.timezones.data.map((item) =>
            item.id === action.payload.response.id
              ? action.payload.response
              : item,
          ),
        };
      })

      //  ADD
      .addCase(AddTimezoneAction.fulfilled, (state, action) => {
        state.timezonesLoading = false;

        state.timezones = {
          ...state.timezones,
          total: Number(state.timezones.total) + 1,
          data: [action.payload.response, ...state.timezones.data],
        };
      });
  },
});

export default timezoneSlice.reducer;
